var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show && _vm.isInPubgmGameApp)?_c('section',{staticClass:"pubgm-mask-wrapper"},[_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(require(`@/assets/images/detail/pubgm/pubgm-hs-mask.jpg`)),expression:"require(`@/assets/images/detail/pubgm/pubgm-hs-mask.jpg`)"}],staticClass:"pubgm-hs-mask",attrs:{"alt":"pubgm-hs-mask"}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }